/* eslint-disable react/prop-types */
import React, { useReducer, createContext, useContext } from 'react'
import { simMod } from '../Module.config'
import { SimutechModule } from '../ModuleTypes'

type LearningLabState = {
    currentSectionId: number
    currentLessonId: number
    currentLab: SimutechModule
}

const initialState: LearningLabState = {
    currentSectionId: 0,
    currentLessonId: 1,
    currentLab: simMod.solverModule,
}

const LearningLabContext = createContext<{
    state: LearningLabState
    dispatch: React.Dispatch<any>
}>({ state: initialState, dispatch: () => null })

enum LearningLabActionType {
    SET_CURRENT_SECTION_ID,
    SET_CURRENT_LESSON_ID,
    SET_CURRENT_LAB
}

export type LearningLabAction =
    {
        type: LearningLabActionType.SET_CURRENT_SECTION_ID
        payload: number
    } |
    {
        type: LearningLabActionType.SET_CURRENT_LESSON_ID
        payload: number
    } |
    {
        type: LearningLabActionType.SET_CURRENT_LAB
        payload: SimutechModule
    }

const learningLabReducer = (state: LearningLabState, action: LearningLabAction) => {
    switch (action.type) {
        case LearningLabActionType.SET_CURRENT_SECTION_ID:
            return { ...state, currentSectionId: action.payload } as LearningLabState
        case LearningLabActionType.SET_CURRENT_LESSON_ID:
            return { ...state, currentLessonId: action.payload } as LearningLabState
        case LearningLabActionType.SET_CURRENT_LAB:
            return { ...state, currentLab: action.payload } as LearningLabState
        default:
            return state
    }
}

const LearningLabProvider: React.FC = ({ children }) => {
    const [state, dispatch] = useReducer(learningLabReducer, initialState)
    return (
        <LearningLabContext.Provider value={{ state, dispatch }}>
            {children}
        </LearningLabContext.Provider>
    )
}

const useLearningLab = () => {
    const context = useContext(LearningLabContext)
    if (!context) {
        throw new Error(
            'useLearningLab must be used within a LearningLabProvider. Wrap a parent component in <LearningLabProvider> to fix this error.'
        )
    }
    return context
}

export { useLearningLab, LearningLabProvider, LearningLabActionType }